// Catálogo plantas → líneas para los selects encadenados del módulo.
//
// Fuente PROPIA del módulo: GET /api/mantenimiento/estructura (mismo gate de
// lectura que el resto — capability `puede_ver_mantenimiento`). TODOS los
// roles usan este endpoint; se acabó la lógica por rol de plataforma y la
// degradación con selects deshabilitados (el usuario dedicado con rol base
// 'lider' + capability ahora tiene estructura como cualquier otro).

import { useQuery } from '@tanstack/react-query';
import { estructuraMttoResponseSchema } from 'schemas';
import { apiGet } from '../../lib/api/client';

export interface PlantaOption {
  id: string;
  nombre: string;
}

export interface LineaOption {
  id: string;
  nombre: string;
  planta_id: string;
}

export interface EstructuraMtto {
  plantas: PlantaOption[];
  lineas: LineaOption[];
  /** false mientras carga o si la petición falló. */
  disponible: boolean;
  cargando: boolean;
}

export function useEstructuraMtto(): EstructuraMtto {
  const q = useQuery({
    // Misma convención que features/mantenimiento/queries.ts: raíz común
    // ['mantenimiento'] para invalidación por módulo.
    queryKey: ['mantenimiento', 'estructura'] as const,
    queryFn: () => apiGet('/api/mantenimiento/estructura', estructuraMttoResponseSchema),
    staleTime: 5 * 60_000,
  });

  return {
    plantas: q.data?.plantas ?? [],
    lineas: q.data?.lineas ?? [],
    disponible: Boolean(q.data),
    cargando: q.isLoading,
  };
}
